import { Component, OnDestroy, OnInit } from '@angular/core';
import { DataService } from '../data.service';
import { Router } from '@angular/router';
import { OAuthService } from 'angular-oauth2-oidc';
import { Capacitor } from '@capacitor/core';
import { AuthService } from '../auth.service';
import { kezdoUrl } from '../kezdo-url';

@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss'],
})
export class LandingComponent implements OnInit, OnDestroy {

  sajatIntezmeny
  /*  A landing eddig NÉMÁN feladta.
   *
   *  Ha a bejelentkezés utáni betöltés bármiért nem futott le, ez a képernyő 20
   *  másodpercig várt, majd egyszerűen ott maradt - üresen, minden magyarázat nélkül.
   *  Kívülről ez úgy néz ki, hogy "a rendszer megakadt a landingon és nem tölt be
   *  semmit", és a felhasználónak esélye sincs kitalálni, mit tegyen.
   *
   *  Mostantól megmondjuk, és adunk kiutat.
   */
  elakadt = false;
  /*  Hol tart a betöltés – az elakadt képernyő kiírja. A telefonon nincs konzol: e nélkül a „csak pörög”
   *  panaszból nem derül ki, melyik lépés nem jött meg (user, 2026-10-16). */
  lepes = 'indul';
  /*  FÜGGETLEN VÉSZKIJÁRAT. A lenti várakozás eddig két helyen némán megállt, és a pörgés örökké tartott:
   *  ha a tároló nem válaszolt (a tick sosem futott újra), és ha a kezdőoldalra navigálást egy őr
   *  elutasította (a tick már visszatért, a landing ottmaradt). Ez az időzítő egyiktől sem függ. */
  private oraKijarat: any = null;

  constructor(
    private data: DataService,
    public oauth: OAuthService,
    private router: Router,
    private auth: AuthService,
  ) { }

  async ngOnInit() {
    this.oraKijarat = setTimeout(() => { this.elakadt = true; }, 25000);
    const standalone = this.auth.isStandalone();
    // Bejelentkezettnek számít: standalone-login → érvényes helyi token; standalone (fix user) → mindig;
    // egyébként (OIDC) → érvényes access token.
    const isLoggedIn = standalone
      ? (this.auth.isStandaloneLogin() ? this.auth.hasValidLocalToken() : true)
      : this.oauth.hasValidAccessToken();

    if (!isLoggedIn) {
      // Standalone-login és nincs token → a bejelentkező képernyőre. (OIDC esetén az AppComponent kezeli.)
      if (standalone && this.auth.isStandaloneLogin()) { this.router.navigateByUrl('/login'); return; }
      // Natív, nem-standalone: ha nincs választott intézmény (pl. kijelentkezés után), az intézményválasztóra.
      // (Ha van választott intézmény, az OidcAuthGuard/AppComponent indítja a login-flow-t.)
      if (!standalone && Capacitor.isNativePlatform() && !this.auth.hasChosenInstitution()) {
        this.router.navigateByUrl('/intezmeny-belepo');
        return;
      }
      // Weben NEM lépünk ki: a token a bejelentkezés után egy pillanattal érkezhet meg.
      // Ha itt megállnánk, a képernyő örökre üres maradna - ezért ugyanúgy várunk, mint
      // a bejelentkezett ágon, csak a végén mást mondunk.
    }

    // Bejelentkezve: megvárjuk, míg az AppComponent felépíti a session-t (sajatIntezmeny), majd a
    // kezdő oldalra navigálunk. Backstop: az AppComponent is navigál sikeres betöltéskor; ha a
    // betöltés hibára fut (nincs intézmény/jogkör), az AppComponent a /login-ra terel.
    let tries = 0;
    const tick = async () => {
      if (this.elakadt) return;
      this.lepes = 'intézményi adatok (' + (isLoggedIn ? 'van belépés' : 'nincs belépés') + ')';
      this.sajatIntezmeny = await this.data.getFromStorage('sajatIntezmeny');
      if (this.sajatIntezmeny) {
        let cel = '/home';
        try {
          //  Az alrendszerhez illő kezdőoldal (a BÉR-program ne a Könyvelés kezdőoldalát nyissa) – kezdo-url.ts.
          cel = kezdoUrl(this.sajatIntezmeny.kezdourl, await this.data.getFromStorage('currentMode'));
        } catch (error) { /* marad a /home */ }
        this.lepes = 'kezdőoldal: ' + cel;
        let sikerult = false;
        try { sikerult = await this.router.navigateByUrl(cel); } catch (e) { /* lent kezeljük */ }
        //  Elutasított navigáció (őr) – egyszer még a /home-ot próbáljuk, utána a vészkijárat jön.
        if (!sikerult && cel !== '/home') {
          this.lepes = 'a kezdőoldal (' + cel + ') nem nyílt meg';
          try { sikerult = await this.router.navigateByUrl('/home'); } catch (e) { /* ignore */ }
        }
        if (!sikerult) this.elakadt = true;
        return;
      }
      if (tries++ < 40) { setTimeout(tick, 500); return; } // ~20 mp-ig várunk az AppComponent betöltésére
      // Lejárt: nem ragadunk üres képernyőn.
      this.elakadt = true;
    };
    setTimeout(tick, 500);
  }

  ngOnDestroy() {
    if (this.oraKijarat) clearTimeout(this.oraKijarat);
  }

  ujra() {
    // Teljes újratöltés: a bejelentkezés utáni betöltés elölről indul.
    window.location.reload();
  }

  belepes() {
    this.router.navigateByUrl('/login');
  }

  /*  TISZTA BELÉPÉS: a tárolt munkamenet (felhasználói adat, intézmény, menü, jogkör) és a jegyek törlése,
   *  majd a szokásos kijelentkezés (natívon az intézményválasztóra). A beragadt, félkész tároló így nem
   *  kíséri át a következő belépésbe. A tároló ürítése legfeljebb 3 mp-et vár – ha az nem válaszol,
   *  akkor is továbblépünk. */
  async tisztaBelepes() {
    try { await Promise.race([this.data.clearStorage(), new Promise((r) => setTimeout(r, 3000))]); } catch (e) { /* ignore */ }
    try { sessionStorage.clear(); } catch (e) { /* ignore */ }
    this.auth.logout();
  }

}
